import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const Msfeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Animation trigger when component enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",
      color: "#fff",
      flexWrap: "wrap",
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(40px)",
      transition: "all 1s ease-in-out",
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "90%",
      maxWidth: "900px",
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div ref={sectionRef} style={styles.container}>
      {/* Right Side (Image) */}
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/ms2.png"
            alt="Multimedia Solutions"
            style={styles.image}
          />
        </div>
      </div>

      {/* Left Side (Text) */}
      <div style={styles.leftSide}>
        <h2 style={styles.header}>Comprehensive Multimedia Solutions</h2>
        <p style={styles.paragraph}>
          Our multimedia solutions combine creativity, technology, and
          interactivity to deliver engaging experiences that capture attention
          and communicate your message effectively. From interactive
          presentations to immersive video content, we help businesses create
          impactful digital assets that resonate with audiences.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> High-quality video production &
            motion graphics
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Interactive e-learning modules
            and training content
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> 2D/3D animations & visual
            storytelling
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Audio production, voiceovers,
            and sound design
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> AR/VR-enabled immersive
            experiences
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Msfeatures;
